// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Vp-z","breadcrumbForward":"Wp-z","breadcrumbBack":"Xp-z","selected":"Yp-z"};